// Shared by the class and the Sentry-suppress meta on useSignIn,
// so the two can never drift out of sync.
export const CLERK_CREDENTIAL_ERROR_NAME = 'ClerkCredentialError';

/**
 * Expected Clerk credential / sign-in control-flow failure shown
 * inline at the login form — not an app fault. Named so:
 * - MutationCache skips it via `meta.suppressSentryErrorNames` (PORTAL-VG)
 * - client `beforeSend` drops unhandledrejection leaks (PORTAL-181 /
 *   PORTAL-19S)
 * Unexpected failures (network, finalize, JSON parse) stay plain
 * `Error`s and still report.
 */
export class ClerkCredentialError extends Error {
  constructor(message: string) {
    super(message);
    this.name = CLERK_CREDENTIAL_ERROR_NAME;
  }
}
